import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import type { LandingSceneId } from "@/data/landingContent";

type ArtProps = {
  className?: string;
};

const SCENE_ART_SRC: Record<LandingSceneId, string> = {
  aeroporto: "/landing-icon-aviao.png",
  restaurante: "/landing-icon-restaurante.png",
  reuniao: "/landing-icon-reuniao.png",
  hotel: "/landing-icon-hotel.png",
  medico: "/landing-icon-medico.png",
  uber: "/landing-icon-carro.png",
};

const Frame = ({
  className,
  children,
  from,
  to,
}: {
  className?: string;
  children: ReactNode;
  from: string;
  to: string;
}) => (
  <div
    className={cn("relative overflow-hidden", className)}
    style={{ background: `linear-gradient(165deg, ${from}, ${to})` }}
    aria-hidden
  >
    <svg viewBox="0 0 240 160" className="h-full w-full" fill="none">
      {children}
    </svg>
  </div>
);

export const SceneArt = ({ id, className }: ArtProps & { id: LandingSceneId }) => (
  <div className={cn("relative overflow-hidden", className)} aria-hidden>
    <img
      src={SCENE_ART_SRC[id]}
      alt=""
      width={960}
      height={640}
      className="h-full w-full object-cover"
    />
  </div>
);

export const StepEnterArt = ({ className }: ArtProps) => (
  <Frame className={className} from="#BFDBFE" to="#EFF6FF">
    <rect x="58" y="28" width="124" height="108" rx="16" fill="#fff" />
    <rect x="74" y="46" width="92" height="12" rx="6" fill="#93C5FD" />
    <rect x="74" y="68" width="64" height="10" rx="5" fill="#BFDBFE" />
    <rect x="74" y="86" width="76" height="10" rx="5" fill="#BFDBFE" />
    <circle cx="154" cy="116" r="20" fill="#2B6BFF" />
    <path d="M147 116l6 6 12-14" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </Frame>
);

export const StepTalkArt = ({ className }: ArtProps) => (
  <Frame className={className} from="#FED7AA" to="#FFF7ED">
    <rect x="28" y="36" width="100" height="40" rx="18" fill="#2B6BFF" />
    <rect x="112" y="84" width="100" height="40" rx="18" fill="#FF7A1A" />
    <circle cx="120" cy="80" r="26" fill="#fff" />
    <rect x="108" y="70" width="7" height="20" rx="3" fill="#2B6BFF" />
    <rect x="118" y="64" width="7" height="32" rx="3" fill="#FF7A1A" />
    <rect x="128" y="70" width="7" height="20" rx="3" fill="#2B6BFF" />
  </Frame>
);

export const StepDebriefArt = ({ className }: ArtProps) => (
  <Frame className={className} from="#BFDBFE" to="#FFF7ED">
    <rect x="40" y="28" width="160" height="108" rx="16" fill="#fff" />
    <circle cx="72" cy="58" r="12" fill="#2B6BFF" />
    <path d="M67 58l3.5 3.5 8-8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    <rect x="94" y="52" width="82" height="10" rx="5" fill="#CBD5E1" />
    <circle cx="72" cy="100" r="12" fill="#FF7A1A" />
    <path d="M67 100h10M72 95v10" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    <rect x="94" y="94" width="64" height="10" rx="5" fill="#FED7AA" />
  </Frame>
);
